import * as React from "react";
import Box from "@mui/material/Box";
import {
  CircularProgress,
  IconButton,
  TextField,
  Typography,
  useMediaQuery,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import InputAdornment from "@mui/material/InputAdornment";
import ClearIcon from "@mui/icons-material/Clear";
import Button from "@mui/material/Button";
import { useDispatch, useSelector } from "react-redux";
import {
  getSearchedSubSellers,
  resetAll,
  resetSearchTerm,
} from "../../redux/slices/subSellerSlice";
import { useTheme } from "@emotion/react";

const SubSellerFilter = ({ clearFilter, subSellerTab }) => {
  const dispatch = useDispatch();
  const theme = useTheme();

  const isMobile = useMediaQuery((theme) =>
    theme.breakpoints.between("sm", "md")
  );
  const isTablet = useMediaQuery((theme) =>
    theme.breakpoints.between("md", "lg")
  );

  const state = useSelector(
    ({
      subSeller: {
        loading,
        isInput,
        searchTerm

      },
    }) => ({
      loading,
      isInput,
      globalSearchTerm: searchTerm
    })
  );

  const [searchTerm, setSearchTerm] = React.useState("");
  const [isValid, setIsValid] = React.useState(true);

  React.useEffect(() => {
    if(subSellerTab) {
    handleClearInput();
    }
    
    setSearchTerm('')
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  React.useEffect(() => {
      setSearchTerm(state.globalSearchTerm);
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [state.globalSearchTerm]);

  const handleFilterChange = (event) => {
    const value =event.target.value;
    setSearchTerm(value);
    if (value.trim()) {
      setIsValid(true);
    } else {
      if(value==='') {
      // setIsValid(false);
      handleClearInput()
      } 
    }
  };

  const handleFilterSubmit = () => {
    dispatch(resetAll())
    dispatch(
      getSearchedSubSellers({
        params: { searchTerm, offset: 0 },
        isInput: true,
      })
    );
    setIsValid(true);
  };

  const handleClearInput = () => {
    setSearchTerm("");
    dispatch(resetAll())
    dispatch(resetSearchTerm())
    dispatch(getSearchedSubSellers({
      params: { status: "SSS001", seller_id:'ALL', offset: 0 },
      isInput: false
    }))
    clearFilter()
  };

  const handleKeyDown = (e) => {
    if (e.which === 13 && e.shiftKey === false && searchTerm) {
      dispatch(resetAll())
      dispatch(
        getSearchedSubSellers({
          params: { searchTerm, offset: 0 },
          isInput: true,
        })
      );
      setIsValid(true);
    }
  }


  return (
    <>
      <>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            flexDirection: isMobile ? 'column': 'row'
          }}>
          <Typography
            variant="h4"
            fontWeight={"600"}
            fontSize={(isMobile || isTablet) ? "1.8rem" : "2.25rem"}
            lineHeight={"2.625rem"}
            sx={{ mb:'1.5rem'}}
          >
            Sub-Seller List
          </Typography>

        </Box>
        <Box
          sx={{
            display: "flex",
            ...((isMobile || isTablet) && { flexDirection: "column" }),
            columnGap: 10,
          }}
        >
          <Box
            sx={{
              display: "flex",
              columnGap: 3,
              mt:3,
              mb: 3.5,
              ...((isMobile || isTablet) && {
                flexDirection: isMobile ? "column" : "row",
                rowGap: 2,
                width: "100%",
              }),
            }}
          >
            <TextField
              type="text"
              label="Find Sub-Seller"
              value={searchTerm}
              onKeyDown={handleKeyDown}
              onChange={handleFilterChange}
              helperText={!isValid && "This field should not be empty"}
              error={!isValid}
              variant={"standard"}
              sx={{
                ...(isMobile || isTablet
                  ? { display: "flex", flex: 1 }
                  : { width: "18rem" })
              }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    {
                      <IconButton
                        sx={{ visibility: !searchTerm.length && "hidden" }}
                        onClick={handleClearInput}
                      >
                        <ClearIcon />{" "}
                      </IconButton>
                    }
                  </InputAdornment>
                ),
              }}
            />
            <Button
              variant="contained"
              sx={{
                ...(isMobile || isTablet
                  ? { display: "flex", flex: 1 }
                  : { width: "6.5rem", maxHeight: "3rem" }),
                boxShadow: "0 0 1rem #ccc",
                borderRadius: ".75rem",
              }}
              disabled={!searchTerm.length}
              onClick={handleFilterSubmit}
            >
              {state.loading && state.isInput ? (
                <CircularProgress
                  thickness={6}
                  size={"1rem"}
                  sx={{ color: theme.palette.primary.contrastText }}
                />
              ) : (
                <SearchIcon />
              )}
            </Button>
          </Box>

        </Box>

      </>
    </>
  );
};
export default SubSellerFilter;
